<template>
    <div class="ExamineRecord">
        <div class="ExamineRecord_title">
            <div class="ExamineRecord_title_left">
                <span style="font-size: 14px;padding-left: 10px;margin-bottom: 10px;border-left: 3px solid var(--subjectColor);">考核记录</span>
            </div>
            <div class="ExamineRecord_title_right">
                <el-button v-if="canEdit &&!isMypersonalRecords" size="mini" @click="addExamineRecord">添加</el-button>
            </div>
        </div>
        <el-table :data="displayExamineRecord" border="1px" style="width: 100%" class="examineRecordList">
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column prop="certificatesName" label="考核年月" align="center" width="180px">
                <template slot-scope="scope">
                    <form-item
                        ref="examineDate"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: '', elementReadonly: 1, elementType: 'date', emptyMessage: '请选择考核年月', errorMessage: null, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '考核年月', propName: 'examineDate', propType: 'java.util.Date', textFormatter: 'yyyy年MM月', valueMaxLength: null, valueMinLength: null, tbFieldName: 'examinedate', iconName: 'rqxzk', model: 'scope.row.examineDate', option: [], formTdAlign: 'text-left', weekday: 0 }"
                        :vo="scope.row"
                        :can-edit="canEdit&&!isMypersonalRecords"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="certificatesSn" label="考核分数" align="center" width="180px">
                <template slot-scope="scope">
                    <form-item
                        ref="examineScore"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入考核分数', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '考核分数', propName: 'examineScore', propType: 'Float', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'scope.row.examineScore', option: [], autocomplete: 'off', showWordLimit: false }"
                        :vo="scope.row"
                        :can-edit="canEdit&&!isMypersonalRecords"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="certificatesDate" label="考核等级" align="center" width="180px">
                <template slot-scope="scope">
                    <form-item
                        ref="examineLevel"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入考核等级', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '考核等级', propName: 'examineLevel', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'scope.row.examineLevel', option: [], autosize: false }"
                        :vo="scope.row"
                        :can-edit="canEdit&&!isMypersonalRecords"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="issuingUnit" label="备注" align="center">
                <template slot-scope="scope">
                    <form-item ref="memo" :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: 70, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入备注', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '备注', propName: 'memo', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'scope.row.memo', option: [], autosize: false }" :vo="scope.row" :can-edit="canEdit&&!isMypersonalRecords" />
                </template>
            </el-table-column>
            <el-table-column v-if="canEdit&&!isMypersonalRecords" label="操作" align="center" width="70px">
                <template slot-scope="scope">
                    <el-link type="primary" @click="delClick(scope.row)">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
        <div class="VacateInfoMore">
            <el-link type="primary" :disabled="allDataLoaded" size="small" icon="el-icon-plus" @click="loadMore">查看更多</el-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExamineRecord',
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        isMypersonalRecords: { type: Boolean, default: false },
        moduleInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    setup() {
        const feeTypeRules = {
            required: true
        }
        return {
            feeTypeRules
        }
    },
    data() {
        return {
            // 通用变量
            loginUser: this.$store.getters.loginUser,
            uploadRow: {},
            chunkSize: 5,
            // 已经加载的条数
            loadedCount: 3,
            displayExamineRecord: [],
            uploadAttachList: [] // 当前待上传附件列表
        }
    },
    computed: {
        allDataLoaded() {
            return this.loadedCount >= this.vo.passenger.examineRecords.length
        }
    },
    watch: {},
    created() {
        this.displayExamineRecord = this.vo.passenger.examineRecords.slice(0, this.loadedCount)
    },
    beforeDestroy() {},
    mounted() {},
    updated() {},
    methods: {
        loadMore() {
            if (this.allDataLoaded) return

            // 计算应该加载的数据起始位置
            const startIndex = this.loadedCount
            // 计算应该加载的数据结束位置
            const endIndex = Math.min(startIndex + this.chunkSize, this.vo.passenger.examineRecords.length)

            // 将新的数据追加到显示数组中
            this.displayExamineRecord = [...this.displayExamineRecord, ...this.vo.passenger.examineRecords.slice(startIndex, endIndex)]

            // 更新已加载的条数
            this.loadedCount = endIndex
        },
        addExamineRecord() {
            this.$http({
                method: 'POST',
                url: '/rsgl/archiveExamineRecord/addNew'
            }).then((res) => {
                console.log(res, 'res')
                if (res.code === 'success') {
                    this.vo.passenger.examineRecords.push(res.body.vo)
                    this.displayExamineRecord = this.vo.passenger.examineRecords
                    this.loadedCount = this.vo.passenger.examineRecords.length
                }
            })
        },
        // 删除当前行
        delClick(row) {
            // 找到要删除的项的索引
            this.vo.passenger.examineRecords = this.vo.passenger.examineRecords.filter((item) => item.id !== row.id)
            this.displayExamineRecord = this.vo.passenger.examineRecords.slice(0, this.loadedCount)
        }
    }
}
</script>

<style scoped lang="scss">
.ExamineRecord_title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // background: #f2f5fb;
    // border: 1px solid #e3e8ee;
    // padding: 4px 6px !important;
    padding: 4px 6px 4px 0 !important;
    font-size: 14px;
    color: #333;
}
.VacateInfoMore {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
}
</style>
